module.exports = __webpack_public_path__ + "static/media/view.landlix.ru_landing_3_.e556bf01.png";